module.exports = __webpack_public_path__ + "img/sec-02-kiwoom.5eef01d9.svg";